type Props = {
  currentQuestion: any;
};

const FileUploadField = ({ currentQuestion }: Props) => {
  const { responses } = currentQuestion;
  const files = responses?.[0]?.files
    ?.map((file: any) => file?.name)
    .join(" , ");

  return <div style={{ fontSize: "14px" }}>{files}</div>;
};

export default FileUploadField;
